<ng-container *ngIf="group">
  <tr 
  *ngIf="group.components"
  class="group-toggle" 
  [attr.depth]="depth">        
      <td (click)="toggleClass($event,'expanded')">
          <span class="d-flex align-items-center">
              <i class="far fa-angle-down"></i> {{group.title ? group.title : (group.label ? group.label : group.name)}}
          </span>
      </td>
      <td *ngFor="let item of properties[0]">
        <span 
          tooltip="{{getValue(item.propertyName)}}" 
          class="overflow-dots nohtml d-block" 
          [innerHTML]="getValue(item.propertyName)"></span>
      </td>
  </tr>
  <tbody *ngIf="group.components">
      <fields-group-property
          *ngFor="let g of group.components;"
          [group]="g"
          [properties]="properties"
          [depth]="depth + 1">
      </fields-group-property>
  </tbody>
  <tr *ngIf="!group.components"
  [attr.depth]="depth">
      <td>{{group.title ? group.title : (group.label ? group.label : group.name)}}</td>
      <td *ngFor="let item of properties[0]"
          class="field-reg-rel">
          <span 
            tooltip="{{getValue(item.propertyName)}}" 
            class="overflow-dots nohtml d-block" 
            [innerHTML]="getValue(item.propertyName)"></span>
      </td>
  </tr>
</ng-container>